import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  getRecentProjects, 
  getRecentPrompts, 
  getRecentExperiments, 
  getFavoriteItems 
} from '../services/api';

// Custom icons matching the existing design system
const HomeIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
);

const SearchIcon = () => (  
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
);

const InboxIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0H4m0 0l4-4m12 4l-4-4" />
  </svg>
);

const FolderIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-5l-2-2H5a2 2 0 00-2 2z" />
  </svg>
);

const ZapIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
);

const UsersIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
  </svg>
);

const FlaskIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
  </svg>
);

const StarIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
  </svg>
);

const PinIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
  </svg>
);

const DockLeftIcon = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <rect x="3" y="4" width="18" height="16" rx="3" ry="3" fill="none" stroke="currentColor" strokeWidth="2"/>
    <rect x="3" y="4" width="6" height="16" rx="3" ry="3" fill="currentColor"/>
  </svg>
);

const ChevronRightIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
  </svg>
);

const MoreIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
  </svg>
);

const LeftDrawer = ({ user, onPinChange }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [recentItems, setRecentItems] = useState({
    projects: [],
    prompts: [],
    experiments: []
  });
  const [favoriteItems, setFavoriteItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const drawerRef = useRef(null);
  const triggerZoneRef = useRef(null);
  const location = useLocation();

  // Don't show drawer on dashboard pages
  const isDashboardPage = location.pathname === '/' || location.pathname === '/dashboard';

  // Load recent items and favorites when component mounts or user changes
  useEffect(() => {
    if (user?.id) {
      loadRecentItems();
      loadFavoriteItems();
    }
  }, [user]);

  const loadRecentItems = async () => {
    try {
      setLoading(true);
      const [projects, prompts, experiments] = await Promise.all([
        getRecentProjects(user.id, 3),
        getRecentPrompts(user.id, 3), 
        getRecentExperiments(user.id, 2)
      ]);

      setRecentItems({
        projects: projects.map(p => ({
          id: p.id,
          name: p.name,
          updatedAt: formatRelativeTime(p.updated_at || p.created_at),
          path: `/projects/${p.id}`
        })),
        prompts: prompts.map(p => ({
          id: p.id,
          name: p.name,
          updatedAt: formatRelativeTime(p.updated_at || p.created_at),
          path: `/prompts/${p.id}`
        })),
        experiments: experiments.map(e => ({
          id: e.id,
          name: e.name,
          updatedAt: formatRelativeTime(e.updated_at || e.created_at),
          path: `/experiments/${e.id}`
        }))
      });
    } catch (error) {
      console.error('Error loading recent items:', error);
      // Fall back to empty arrays if API fails
      setRecentItems({
        projects: [],
        prompts: [],
        experiments: []
      });
    } finally {
      setLoading(false);
    }
  };

  const loadFavoriteItems = async () => {
    try {
      const favorites = await getFavoriteItems(user.id);
      setFavoriteItems(favorites || []);
    } catch (error) {
      console.error('Error loading favorite items:', error);
      setFavoriteItems([]);
    }
  };

  // Helper function to format relative time
  const formatRelativeTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} min ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)} days ago`;
    return date.toLocaleDateString();
  };

  // Navigation sections - only static top-level items
  const staticNavigationSections = [
    {
      title: '',
      items: [
        { icon: SearchIcon, label: 'Search', path: '/search', badge: null },
        { icon: HomeIcon, label: 'Dashboard', path: '/', badge: 'New' },
        { icon: InboxIcon, label: 'Inbox', path: '/inbox', badge: null },
      ]
    }
  ];

  // Dynamic favorites section
  const favoritesSection = favoriteItems.length > 0 ? [{
    title: 'Favorites',
    items: favoriteItems.map(fav => ({
      icon: StarIcon,
      label: fav.name,
      path: fav.itemType === 'project' ? `/projects/${fav.itemId}` : 
            fav.itemType === 'prompt' ? `/prompts/${fav.itemId}` :
            fav.itemType === 'experiment' ? `/experiments/${fav.itemId}` : '#',
      emoji: fav.itemType === 'project' ? '📁' : 
             fav.itemType === 'prompt' ? '⚡' : 
             fav.itemType === 'experiment' ? '🧪' : '⭐'
    }))
  }] : [];

  // Dashboard section - common navigation items
//   const dashboardSection = [{
//     title: 'Dashboard',
//     items: [
//       { icon: FolderIcon, label: 'Projects', path: '/dashboard', emoji: '📊' },
//       { icon: ZapIcon, label: 'My Prompts', path: '/dashboard', emoji: '⚡' },
//       { icon: UsersIcon, label: 'Shared Prompts', path: '/shared-prompts', emoji: '👥' },
//       { icon: FlaskIcon, label: 'Experiments', path: '/dashboard', emoji: '🧪' },
//     ]
//   }];

  // Handle pin state changes and notify parent
  useEffect(() => {
    if (onPinChange) {
      // If we're on dashboard page, always report unpinned state
      onPinChange(isDashboardPage ? false : isPinned);
    }
  }, [isPinned, onPinChange, isDashboardPage]);

  // Handle body scroll lock when drawer is visible but not pinned
  useEffect(() => {
    if (isVisible && !isPinned) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isVisible, isPinned]);

  // Handle mouse movement for trigger zone
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      
      // Show drawer if mouse is near left edge and not already pinned
      if (!isPinned) {
        if (e.clientX <= 20) { // 20px trigger zone from left edge
          setIsVisible(true);
        } else if (e.clientX > 280 && !drawerRef.current?.contains(e.target)) {
          // Hide drawer if mouse moves away and not hovering over drawer
          setIsVisible(false);
        }
      }
    };

    const handleMouseLeave = () => {
      if (!isPinned && !drawerRef.current?.contains(document.querySelector(':hover'))) {
        setIsVisible(false);
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [isPinned]);

  // Early return if on dashboard page (after all hooks)
  if (isDashboardPage) {
    return null;
  }

  // Get the current active path
  const isActivePath = (path) => {
    if (path === '/' && location.pathname === '/dashboard') return true;
    if (path === '/' && location.pathname === '/') return true;
    return location.pathname.startsWith(path) && path !== '/';
  };

  // Render a navigation item
  const renderNavItem = ({ icon: Icon, label, path, badge, emoji }) => (
    <Link
      key={path}
      to={path}
      className={`group flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
        isActivePath(path)
          ? 'bg-celadon-100 text-celadon-800 border border-celadon-200'
                          : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-gray-100'
      }`}
    >
      <div className="flex items-center space-x-3 flex-1 min-w-0">
        {emoji ? (
          <span className="text-lg flex-shrink-0">{emoji}</span>
        ) : (
          <Icon className={`flex-shrink-0 ${
            isActivePath(path) ? 'text-celadon-600' : 'text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-300'
          }`} />
        )}
        <span className="truncate">{label}</span>
      </div>
      {badge && (
        <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-celadon-100 text-celadon-800">
          {badge}
        </span>
      )}
    </Link>
  );

  // Render recent items
  const renderRecentSection = (title, items, icon) => (
    <div key={title} className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide">{title}</h3>
        <button className="text-gray-400 hover:text-gray-600 transition-colors">
          <MoreIcon />
        </button>
      </div>
      <div className="space-y-1">
        {items.slice(0, 3).map((item) => (
          <Link
            key={item.id}
            to={item.path}
            className="group flex items-center px-3 py-2 text-sm rounded-lg transition-all duration-200 hover:bg-gray-100"
          >
            {React.createElement(icon, { className: "w-4 h-4 text-gray-400 group-hover:text-gray-600 flex-shrink-0" })}
            <div className="ml-3 flex-1 min-w-0">
              <p className="text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-gray-100 truncate font-medium">
                {item.name}
              </p>
              <p className="text-xs text-gray-500">{item.updatedAt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );

  return (
    <>
      {/* Invisible trigger zone */}
      <div
        ref={triggerZoneRef}
        className="fixed left-0 top-0 w-5 h-full z-40 pointer-events-auto"
        style={{ zIndex: 40 }}
      />

      {/* Drawer */}
      <div
        ref={drawerRef}
        className={`fixed left-0 top-0 h-full w-80 bg-white/95 dark:bg-gray-900/95 backdrop-blur-xl border-r border-gray-200/50 dark:border-gray-700/50 ${!isPinned ? 'shadow' : ''} z-50 transform transition-all duration-300 ease-out ${
          isVisible || isPinned ? 'translate-x-0' : '-translate-x-full'
        }`}
        onMouseEnter={() => !isPinned && setIsVisible(true)}
        onMouseLeave={() => !isPinned && setIsVisible(false)}
        onWheel={(e) => {
          // Prevent page scroll when interacting with drawer
          e.stopPropagation();
        }}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200/50">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-gradient-celadon rounded-xl flex items-center justify-center">
              <img src="/banyan-icon.jpeg" alt="Banyan" className="w-5 h-5" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Workspace</h2>
            </div>
          </div>
          
          {/* Pin toggle */}
          <button
            onClick={() => setIsPinned(!isPinned)}
            className={`p-2 rounded-lg transition-all duration-200 ${
              isPinned 
                ? 'bg-celadon-100 text-celadon-700 hover:bg-celadon-200' 
                : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
            }`}
            title={isPinned ? 'Undock drawer' : 'Dock drawer to left'}
          >
            <DockLeftIcon />
          </button>
        </div>

        {/* Content */}
        <div 
          className="flex-1 overflow-y-auto custom-scrollbar p-6"
          onWheel={(e) => {
            // Prevent page scroll when scrolling inside the drawer
            e.stopPropagation();
          }}
        >
          {/* Static Navigation Sections */}
          {staticNavigationSections.map((section, sectionIndex) => (
            <div key={sectionIndex} className="mb-8">
              {section.title && (
                <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                  {section.title}
                </h3>
              )}
              <nav className="space-y-1">
                {section.items.map(renderNavItem)}
              </nav>
            </div>
          ))}

          {/* Favorites Section */}
          {favoritesSection.map((section, sectionIndex) => (
            <div key={`favorites-${sectionIndex}`} className="mb-8">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                {section.title}
              </h3>
              <nav className="space-y-1">
                {loading ? (
                  Array.from({ length: 2 }).map((_, index) => (
                    <div key={index} className="flex items-center px-3 py-2">
                      <div className="w-4 h-4 bg-gray-200 rounded animate-pulse flex-shrink-0" />
                      <div className="ml-3 flex-1">
                        <div className="h-4 bg-gray-200 rounded animate-pulse" />
                      </div>
                    </div>
                  ))
                ) : (
                  section.items.map(renderNavItem)
                )}
              </nav>
            </div>
          ))}

          {/* Dashboard Section */}
          {/* {dashboardSection.map((section, sectionIndex) => (
            <div key={`dashboard-${sectionIndex}`} className="mb-8">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                {section.title}
              </h3>
              <nav className="space-y-1">
                {section.items.map(renderNavItem)}
              </nav>
            </div>
          ))} */}

          {/* Recent Items Sections */}
          <div className="mt-8 pt-6 border-t border-gray-200/50">
            {loading ? (
              <div className="space-y-6">
                {['Projects', 'My Prompts', 'Experiments'].map((title) => (
                  <div key={title} className="mb-6">
                    <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">{title}</h3>
                    <div className="space-y-1">
                      {Array.from({ length: 2 }).map((_, index) => (
                        <div key={index} className="flex items-center px-3 py-2">
                          <div className="w-4 h-4 bg-gray-200 rounded animate-pulse flex-shrink-0" />
                          <div className="ml-3 flex-1">
                            <div className="h-4 bg-gray-200 rounded animate-pulse mb-1" />
                            <div className="h-3 bg-gray-200 rounded animate-pulse w-16" />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {recentItems.projects.length > 0 && renderRecentSection('Projects', recentItems.projects, FolderIcon)}
                {recentItems.prompts.length > 0 && renderRecentSection('My Prompts', recentItems.prompts, ZapIcon)}
                {recentItems.experiments.length > 0 && renderRecentSection('Experiments', recentItems.experiments, FlaskIcon)}
                
                {/* Show message if no recent items at all */}
                {recentItems.projects.length === 0 && recentItems.prompts.length === 0 && recentItems.experiments.length === 0 && (
                  <div className="text-center py-8">
                    <div className="text-gray-400 mb-2">📋</div>
                    <p className="text-sm text-gray-500">No recent activity</p>
                    <p className="text-xs text-gray-400 mt-1">Start creating projects and prompts</p>
                  </div>
                )}
              </>
            )}
          </div>

          {/* More Section */}
          <div className="mt-8 pt-6 border-t border-gray-200/50">
            <button className="group flex items-center px-3 py-2 text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-all duration-200 w-full">
              <br/>
              <span>More</span>
              <br/>
              <ChevronRightIcon className="w-4 h-4 ml-auto group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>

      {/* Overlay for unpinned drawer */}
      {isVisible && !isPinned && (
        <div 
          className="fixed inset-0 bg-black/20 z-40 backdrop-blur-sm"
          onClick={() => setIsVisible(false)}
        />
      )}
    </>
  );
};

export default LeftDrawer; 